import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-eff418c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mbp" }
const _hoisted_2 = { class: "mbp__modal" }
const _hoisted_3 = { class: "mbp__modal-row-col" }
const _hoisted_4 = { class: "mbp__modal-row-col-icon" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "mbp__modal-row-num"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPayment = _resolveComponent("IconPayment")!
  const _component_IconChannels = _resolveComponent("IconChannels")!
  const _component_IconExit = _resolveComponent("IconExit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "mbp__overlay",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hiddenModal && _ctx.hiddenModal(...args)))
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(
					index === _ctx.ICON.CHANNELS
						? 'mbp__modal-row_line'
						: 'mbp__modal-row'
				)
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.ICON.PAY === index)
                ? (_openBlock(), _createBlock(_component_IconPayment, { key: 0 }))
                : _createCommentVNode("", true),
              (_ctx.ICON.CHANNELS === index)
                ? (_openBlock(), _createBlock(_component_IconChannels, {
                    key: 1,
                    color: "rgb(188, 192, 207)"
                  }))
                : _createCommentVNode("", true),
              (_ctx.ICON.EXIT === index)
                ? (_openBlock(), _createBlock(_component_IconExit, { key: 2 }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.onClickRedirect(item.routeName)),
              class: "mbp__modal-row-col-label"
            }, _toDisplayString(item.name), 9, _hoisted_5)
          ]),
          (_ctx.ICON.CHANNELS === index)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.num), 1))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ])
  ]))
}